<script setup lang="ts">

</script>

<template>
  <div>
    <slot name="header" />

    <main>
      <slot />
    </main>
  </div>
</template>
